<div class="modal-container">
    <div class="modal-header">
        <h2 class="modal-title">
            <span *ngIf="type=='approve'">{{globalConstants.APPROVAL_HEADER}}</span>
            <span *ngIf="type=='reject'">{{globalConstants.REJECT_HEADER}} <span class="required-text">*</span></span>
            <span *ngIf="type=='return'">{{globalConstants.RETURN_HEADER}} <span class="required-text">*</span></span>
            <span *ngIf="type=='revoke'">{{globalConstants.REVOKE_HEADER}} <span class="required-text">*</span></span>
            <span *ngIf="type=='suspend'">{{globalConstants.SUSPEND_HEADER}}<span class="required-text">*</span></span>
            <span *ngIf="type=='resume'">{{globalConstants.RESUME_HEADER}}<span class="required-text">*</span></span>
            <span *ngIf="type=='action'">{{globalConstants.ACTION_HEADER}}<span class="required-text">*</span></span>
            <span *ngIf="type=='confirm'">{{globalConstants.CONFIRM_HEADER}}<span class="required-text">*</span></span>
            <span *ngIf="requestType==='Suspension'">{{globalConstants.SUSPEND_CONFIRM_UPDATE_HEADER}}</span>
            <span *ngIf="requestType==='Revocation'">{{globalConstants.REVOKE_CONFIRM_UPDATE_HEADER}}</span>
            <span *ngIf="requestType==='Termination'">{{globalConstants.TERMINATION_CONFIRM_UPDATE_HEADER}}</span>
            <span *ngIf="type=='onBoardConfirm'">{{globalConstants.ONBOARD_CONFIRM_MSG}} {{modalData}}</span>
        </h2>
        <div class="pull-right d-flex align-items-center">
            <button type="button" class="close btn-close" (mousedown)="onClose('close')" aria-label="Close">
                <span aria-hidden="true" *ngIf="type!=='confirm' && type!='confirmRequest'">&times;</span>
            </button>
            <button type="button" class="close btn-close" (mousedown)="onClose('cancel')" aria-label="Close">
                <span aria-hidden="true" *ngIf="(type==='confirm' || type==='confirmRequest')">&times;</span>
            </button>
        </div>
    </div>
    <div class="modal-body">
        <form [formGroup]="requestApprovalForm" autocomplete="one-time-code">
            <div class="need-access-form-container">
                <div class="textarea-input-wrap mt-30" *ngIf="type=='approve'">
                    <label for="nameSearch"
                        class="form-label form-label-custom">{{globalConstants.APPROVAL_LABEL}}</label>
                </div>
                <div class="textarea-input-wrap mt-30" *ngIf="type=='confirm'">
                    <label for="nameSearch" class="form-label form-label-custom">{{globalConstants.CONFIRM_LABEL}}
                        <span *ngIf="requestType==='Suspend'">{{globalConstants.SUSPEND_CONFIRM_LABEL}}</span>
                        <span *ngIf="requestType==='Revoke'">{{globalConstants.REVOKE_CONFIRM_LABEL}}</span>
                    </label>
                </div>
                <div class="textarea-input-wrap mt-30" *ngIf="type=='confirmRequest'">
                    <label for="nameSearch" class="form-label form-label-custom"
                        *ngIf="requestType==='Suspension'">{{globalConstants.SUSPEND_CONFIRM_UPDATE_DET}}</label>
                    <label for="nameSearch" class="form-label form-label-custom"
                        *ngIf="requestType==='Revocation'">{{globalConstants.REVOKE_CONFIRM_UPDATE_DET}}</label>
                    <label for="nameSearch" class="form-label form-label-custom"
                        *ngIf="requestType==='Termination'">{{globalConstants.TERMINATION_CONFIRM_UPDATE_DET}}</label>
                </div>
                <div class="textarea-input-wrap mt-30" *ngIf="type=='action'">
                    <label for="nameSearch"
                        class="form-label form-label-custom">{{globalConstants.ACTION_LABEL}}</label>
                </div>
                <div class="textarea-input-wrap mt-30" *ngIf="type=='reject'">
                    <textarea class="form-control form-control-custom" rows="3"
                        placeholder="{{globalConstants.REJECT_LABEL}}" formControlName="rejectReason" maxlength="500"
                        #rejectReason appTrim spellcheck="false" appCharOnlyWithspl
                        autocomplete="one-time-code"></textarea>
                    <span class="text-limit">{{rejectReason.value.length}} /
                        {{globalConstants._500_CHARACTER_LEFT_NEW_SYS_ACCESS}} </span>
                </div>
                <div class="textarea-input-wrap mt-30" *ngIf="type=='return'">
                    <textarea class="form-control form-control-custom" rows="3"
                        placeholder="{{globalConstants.RETURN_LABEL}}" formControlName="returnReason" maxlength="500"
                        #returnReason appTrim spellcheck="false" appCharOnlyWithspl
                        autocomplete="one-time-code"></textarea>
                    <span class="text-limit">{{returnReason.value.length}} /
                        {{globalConstants._500_CHARACTER_LEFT_NEW_SYS_ACCESS}} </span>
                </div>

                <div class="textarea-input-wrap mt-30" *ngIf="type=='revoke'">
                    <textarea class="form-control form-control-custom" rows="3"
                        placeholder="{{globalConstants.REVOKE_LABEL}}" formControlName="revokeReason" maxlength="500"
                        #returnReason appTrim spellcheck="false" appCharOnlyWithspl
                        autocomplete="one-time-code"></textarea>
                    <span class="text-limit">{{returnReason.value.length}} /
                        {{globalConstants._500_CHARACTER_LEFT_NEW_SYS_ACCESS}} </span>
                </div>

                <div class="textarea-input-wrap mt-30" *ngIf="type=='suspend'">
                    <textarea class="form-control form-control-custom" rows="3"
                        placeholder="{{globalConstants.SUSPEND_LABEL}}" formControlName="suspendReason" maxlength="500"
                        #returnReason appTrim spellcheck="false" appCharOnlyWithspl
                        autocomplete="one-time-code"></textarea>
                    <span class="text-limit">{{returnReason.value.length}} /
                        {{globalConstants._500_CHARACTER_LEFT_NEW_SYS_ACCESS}} </span>
                </div>

                <div class="textarea-input-wrap mt-30" *ngIf="type=='resume'">
                    <textarea class="form-control form-control-custom" rows="3"
                        placeholder="{{globalConstants.RESUME_LABEL}}" formControlName="resumeReason" maxlength="500"
                        #returnReason appTrim spellcheck="false" appCharOnlyWithspl
                        autocomplete="one-time-code"></textarea>
                    <span class="text-limit">{{returnReason.value.length}} /
                        {{globalConstants._500_CHARACTER_LEFT_NEW_SYS_ACCESS}} </span>
                </div>

                <div class="textarea-input-wrap mt-30" *ngIf="type=='onBoardConfirm'">
                    <label for="nameSearch"
                        class="form-label form-label-custom">{{globalConstants.ONBOARD_PROCEED_MSG}}</label>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer d-flex justify-content-end">
        <button class="btn btn-outline" (click)="clearForm()"
            *ngIf="type!='approve' && type!='action' && type!='confirm' && type!='confirmRequest' && type!='onBoardConfirm'">{{globalConstants.CLEAR_NEW_SYS_ACCESS}}</button>
        <button class="btn btn-outline" (click)="onClose('cancel')"
            *ngIf="type==='confirm'">{{globalConstants.CANCEL_SYS_ACCESS}}</button>
        <button class="btn btn-orange" (click)="onClose('confirm')"
            *ngIf="type==='confirm'">{{globalConstants.CONFIRM_SYS_ACCESS}}</button>
        <button class="btn btn-outline" (click)="onClose('cancel')"
            *ngIf="type==='confirmRequest'">{{globalConstants.CANCEL_SYS_ACCESS}}</button>
        <button class="btn btn-orange" (click)="onClose('confirmRequest')"
            *ngIf="type==='confirmRequest'">{{globalConstants.CONFIRM_SYS_ACCESS}}</button>
        <button type="submit" class="btn btn-orange" (click)="onClose('submit')"
            *ngIf="type !='approve' && type!='action' && type!='confirm' && type!='confirmRequest' && type!='onBoardConfirm'"
            [disabled]="getDisabledStatus()">{{globalConstants.SUBMIT_BTN_LABEL}}</button>
        <button type="submit" class="btn btn-orange" (click)="onClose('approve')"
            *ngIf="type=='approve'">{{globalConstants.APPROVE_BTN_LABEL}}</button>
        <button type="submit" class="btn btn-orange" (click)="onClose('revokeAccess')"
            *ngIf="type=='action'">{{globalConstants.REVOKE_ACCESS_BTN_LABEL}}</button>
        <button type="submit" class="btn btn-outline" (click)="onClose('suspendAccess')"
            *ngIf="type=='action' && status === 'Approved' && requestType!=='Suspension Request'">{{globalConstants.SUSPEND_ACCESS_BTN_LABEL}}</button>
        <button type="submit" class="btn btn-outline" (click)="onClose('resumeAccess')"
            *ngIf="type=='action' && status === 'Approved' && requestType ==='Suspension Request'">{{globalConstants.RESUME_ACCESS_BTN_LABEL}}</button>
        <button class="btn btn-outline" (click)="onClose('close')"
            *ngIf="type==='onBoardConfirm'">{{globalConstants.CANCEL_SYS_ACCESS}}</button>
        <button type="submit" class="btn btn-orange" (click)="onClose('onBoardProceed')"
            *ngIf="type=='onBoardConfirm'">{{globalConstants.ONBOARD_PROCEED_LABEL}}</button>
    </div>
</div>